import { MarkerType } from "typings/microserviceModels/packaging-flex-module";
import { UitkDealBundledBadge } from "uitk-react-badge";
import { useLocalization } from "@shared-ui/localization-context";
import * as React from "react";
import { SavingBadgeProps } from "components/flexComponents/Packages/typings";
import { UitkLayoutPosition } from "uitk-react-layout-position";

const SavingBadge: React.FC<SavingBadgeProps> = ({ markers, renderSpace, overImage }) => {
  const { formatText } = useLocalization();
  const hasFreeFlightMarker = markers?.some((marker: MarkerType) => marker.sticker === "PkgSavingsFreeFlight");
  const savingBadge = <UitkDealBundledBadge text={formatText("package.card.badge.flightSavings", 100)} />;
  if (hasFreeFlightMarker) {
    if (overImage) {
      return (
        <UitkLayoutPosition type="absolute" position={{ top: "minus-three", right: "two" }}>
          {savingBadge}
        </UitkLayoutPosition>
      );
    }

    return savingBadge;
  }

  return renderSpace ? <div className="s-y-margin-one" /> : null;
};

export default SavingBadge;
